import { AuthOperationType } from '../../server/middlewares/ssos/utils/sso.utils.js'

export const convertRedirectParamsToPath = (redirect: string) => {
  const sanitizedUri = sanitizeAndDecodeUri(redirect)

  return sanitizedUri
}

const sanitizeAndDecodeUri = (uri: string) => {
  if (!uri) {
    return '/'
  }

  const decodedUri = decodeURIComponent(uri)

  // Prevent redirecting to unrecognized external paths
  if (
    decodedUri.substring(0, 1) !== '/' ||
    decodedUri.substring(0, 2) === '//'
  ) {
    return '/'
  }

  return decodedUri
}

export const getFailedAuthRedirectUri = (
  operation: AuthOperationType,
  redirectPath: string,
) => {
  const params = new URLSearchParams()

  if (redirectPath) {
    params.append('redirect', redirectPath)
  }

  if (operation === AuthOperationType.signup) {
    return getFailedSignupRedirectUri(params)
  }

  if (operation === AuthOperationType.login) {
    return getFailedLoginRedirectUri(params)
  }

  return undefined
}

const getFailedLoginRedirectUri = (optionalParams: URLSearchParams) => {
  const query = optionalParams.toString()
  return `/auth/login${query.length ? `?${query}` : ''}`
}

const getFailedSignupRedirectUri = (optionalParams: URLSearchParams) => {
  const query = optionalParams.toString()
  return `/auth/signup${query.length ? `?${query}` : ''}`
}

export const getRedirectParamsFromQuery = (
  query: Record<string, string>,
): string => {
  return query?.redirect ?? ''
}
